<template>
  <div>
    <div class="Layout">
      <div class="Layout__Navbar">
        <div class="Layout__Navbar__Logo">
          <img :src=logo alt="" />
        </div>
        <h1 class="Layout__Navbar__Title">{{ title }}</h1>
      </div>
      <div class="Layout__Content__Editor__Indicator" v-if="!getInProgress && activeTab !== 1">
        <div>
          <span>{{ titleText }}</span>
          <span v-if="documentCount">(מסמך {{ documentNumber }} מתוך {{ documentCount }})</span>
          <!-- <button
            @click="goToNextField"
            v-if="!isDocumentValid"
            class="Layout__Content__Editor__Indicator__Next clickable"
          >
            {{ getUploadAttributes.length && activeTab === 0 ? 'להעלאת מסמכים' : 'הבא' }}
          לחתימה הבאה
          </button>
          <button @click="finish"
            v-if="isDocumentValid"
            :disabled="inProgress"
            :class="inProgress ? 'disabled' : ''"
          >
            <span v-if="!nextDocumentRecipient">סיים</span>
            <span v-if="nextDocumentRecipient">למסמך הבא</span>
        </button> -->
        </div>
      </div>
      <div class="Layout__Content" :class="{ 'upload-bg': activeTab === 1 }" ref="container" v-if="!getInProgress && (!images || images.length || html)">
        <div v-if="activeTab === 0" class="Layout__Content__Editor scroller" ref="editor">
          <div v-html="html" v-if="html" class="Layout__Content__Page rtl html">

          </div>
          <div v-if="hasEmptySignatures">
            <div class="Layout__Content__Page" v-for="(image, index) in images" :key="index">
              <img :src="`data:image/jpg;base64, ${image.data}`" alt="" />
              <div class="Layout__Content__Page__Attributes" v-if="getAttributes(index + 1)">
                <div class="Layout__Content__Page__Attributes__Item clickable" :class="{
                  required: attr.required,
                  valid: attr.isValid,
                  [`type-${attr.type}`]: true,
                  'preview-mode': isPreviewMode && attr.type === 'signature',
                  [getBackgroundColor(attr.assigneeNumber)]: isPreviewMode && attr.type === 'signature'
                }" @click="!isPreviewMode && onAttributeClick($event, attr)" v-for="(attr, index) in getAttributes(index + 1)"
                  :key="index" :style="{
                    width: `${attr.width}px`,
                    height: `${attr.height}px`,
                    position: 'absolute',
                    transform: `translate(${attr.x}px, ${attr.y}px)`,
                  }">
                  חתימה
                </div>
              </div>
              <!-- Signed attributes (signatures, dates, labels, textboxes, checkboxes) -->
              <div class="Layout__Content__Page__Attributes" v-if="getSignedAttributes(index + 1)">
                <div 
                  :class="[
                    'signed-attribute',
                    attr.type === 'signature' ? 'signed-signature' : '',
                    attr.type === 'signatureDate' || attr.type === 'assigneeName' || attr.type === 'label' || attr.type === 'textbox' ? 'signed-text-field' : '',
                    attr.type === 'checkbox' ? 'signed-checkbox-field' : '',
                    {
                      required: attr.required,
                      valid: attr.isValid,
                      [`type-${attr.type}`]: true,
                      'preview-mode': isPreviewMode && attr.type === 'signature',
                      [getBackgroundColor(attr.assigneeNumber)]: isPreviewMode && attr.type === 'signature'
                    }
                  ]" 
                  v-for="(attr, index) in getSignedAttributes(index + 1)"
                  :key="index" 
                  :style="{
                    width: `${attr.type === 'checkbox' ? 28 : attr.width}px`,
                    height: `${attr.type === 'checkbox' ? 28 : attr.height}px`,
                    position: 'absolute',
                    transform: `translate(${attr.x}px, ${attr.y}px)`,
                    background: attr.type === 'signature' ? `url('${attr.value}') no-repeat center` : 'transparent',
                  }"
                >
                  <!-- Render text-based fields (dates, labels, assignee names, textboxes) -->
                  <span 
                    v-if="attr.type === 'signatureDate' || attr.type === 'assigneeName' || attr.type === 'label' || attr.type === 'textbox'"
                    class="signed-text-content"
                  >
                    {{ attr.value }}
                  </span>
                  
                  <!-- Render checkbox -->
                  <input 
                    v-if="attr.type === 'checkbox'"
                    type="checkbox" 
                    :checked="attr.value === true || attr.value === 'true'"
                    disabled
                    class="signed-checkbox"
                  />
                </div>
              </div>
              <div class="Layout__Content__Page__Attributes" v-if="getDatesAttributes(index + 1)">
                <div class="Layout__Content__Page__Attributes__Custom__Item" :class="{
                  required: attr.required,
                  valid: attr.isValid,
                  [`type-${attr.type}`]: true,
                  'preview-mode': isPreviewMode,
                  [getBackgroundColor(attr.assigneeNumber)]: isPreviewMode
                }" @click="onAttributeClick($event, attr)" v-for="(attr, index) in getDatesAttributes(index + 1)"
                  :key="index" :style="{
                    width: `${attr.width}px`,
                    height: `${attr.height}px`,
                    position: 'absolute',
                    transform: `translate(${attr.x}px, ${attr.y}px)`,
                  }">
                  <span v-if="isPreviewMode">תאריך חתימה</span>
                  <span v-else>{{ attr.value }}</span>
                </div>
              </div>
              
              <div class="Layout__Content__Page__Attributes" v-if="getAssigneeNameAttributes(index + 1)">
                <div class="Layout__Content__Page__Attributes__Custom__Item" :class="{
                  required: attr.required,
                  valid: attr.isValid,
                  [`type-${attr.type}`]: true,
                  'preview-mode': isPreviewMode,
                  [getBackgroundColor(attr.assigneeNumber)]: isPreviewMode
                }" @click="onAttributeClick($event, attr)" v-for="(attr, index) in getAssigneeNameAttributes(index + 1)"
                  :key="index" :style="{
                    width: `${attr.width}px`,
                    height: `${attr.height}px`,
                    position: 'absolute',
                    transform: `translate(${attr.x}px, ${attr.y}px)`,
                  }">
                  <span v-if="isPreviewMode">שם החותם/ת</span>
                  <span v-else>{{ attr.value }}</span>
                </div>
              </div>
              
              <div class="Layout__Content__Page__Attributes" v-if="getLabelAttributes(index + 1)">
                <div class="Layout__Content__Page__Attributes__Custom__Item" :class="{
                  required: attr.required,
                  valid: attr.isValid,
                  [`type-${attr.type}`]: true,
                  'preview-mode': isPreviewMode,
                  [getBackgroundColor(attr.assigneeNumber, attr.type)]: isPreviewMode
                }" @click="onAttributeClick($event, attr)" v-for="(attr, index) in getLabelAttributes(index + 1)"
                  :key="index" :style="{
                    width: `${attr.width}px`,
                    height: `${attr.height}px`,
                    position: 'absolute',
                    transform: `translate(${attr.x}px, ${attr.y}px)`,
                  }">
                  {{ attr.value }}
                </div>
              </div>
              
              <div class="Layout__Content__Page__Attributes" v-if="getTextboxAttributes(index + 1)">
                <div class="Layout__Content__Page__Attributes__Custom__Item" :class="{
                  required: attr.required,
                  valid: attr.isValid,
                  [`type-${attr.type}`]: true,
                  [getBackgroundColor(attr.assigneeNumber, attr.type)]: isPreviewMode
                }" v-for="(attr, index) in getTextboxAttributes(index + 1)"
                  :key="index" :style="{
                    width: `${attr.width}px`,
                    height: `${attr.height}px`,
                    position: 'absolute',
                    transform: `translate(${attr.x}px, ${attr.y}px)`,
                  }">
                  <input 
                    type="text" 
                    v-model="attr.value"
                    :placeholder="attr.displayText || 'שדה טקסט'"
                    class="textbox-input"
                    @input="onTextboxInput(attr)"
                  />
                </div>
              </div>
              
              <div class="Layout__Content__Page__Attributes" v-if="getCheckboxAttributes(index + 1)">
                <div class="Layout__Content__Page__Attributes__Custom__Item" :class="{
                  required: attr.required,
                  valid: attr.isValid,
                  [`type-${attr.type}`]: true,
                  [getBackgroundColor(attr.assigneeNumber, attr.type)]: isPreviewMode
                }" v-for="(attr, index) in getCheckboxAttributes(index + 1)"
                  :key="index" :style="{
                    width: `${attr.width}px`,
                    height: `${attr.height}px`,
                    position: 'absolute',
                    transform: `translate(${attr.x}px, ${attr.y}px)`,
                  }">
                  <input 
                    type="checkbox" 
                    :checked="attr.isChecked"
                    class="checkbox-input"
                    @change="onCheckboxChange($event, attr)"
                  />
                </div>
              </div>

            </div>
          </div>
        </div>
        <div v-if="activeTab === 1" class="Layout__Content__Editor scroller upload-tab-content">
          <UploadRequest
            :upload-attributes="getUploadAttributes"
            :document-short-url="documentShortUrl"
            :document-token="documentToken"
            :rep-name="documentOwner || ''"
            :client-name="clientName || ''"
            :is-sending="isUploadSending"
            :was-sent="uploadWasSent"
            @send="onUploadSend"
            @finish="onUploadFinish" />
        </div>
        <div v-if="activeTab === 2" class="Layout__Content__Editor">
          <div class="message-section">
            <div class="send-to-container">
              <h1>כתוב הודעה לרואה חשבון</h1>
              <textarea placeholder="הודעה..." v-model="sendToMessage" cols="30" rows="10"></textarea>
            </div>
          </div>
        </div>
        <div style="width: 100% !important;" v-if="activeTab === 9" class="Layout__Content__Editor">
          <div class="success">
            <!-- <div class="success-date">
              <font-awesome-icon size="1x" icon="fa-solid fa-calendar" />
              <div>21.06.2024</div>
            </div> -->
            <div class="success-image">
              <img :src=stampLogo alt="" />
            </div>
            <div class="success-title">
              <p>המסמכים נשלחו למייצגך.</p>
              <p>ניתן לסגור דף זה.</p>
            </div>
            <div class="success-download">
              <p v-if="!signedDocumentBlob" class="success-download-preparing">מכין מסמך חתום...</p>
              <p v-else>להורדת המסמך החתום <span class="download-link" @click="downloadSignedDocument">לחץ כאן</span></p>
            </div>
            <!-- <div class="success-message">
              לצורך מענה מקצועי, זמין ואיכותי אנו מעמידים לשירותך את מרכז שירות הלקוחות שלנו בטל':
              <span>03-6897444</span> 
              או בדוא"ל
              <span>info@heshev.co.il</span>
            </div> -->
          </div>
        </div>
      </div>
      <div v-if="!getInProgress && !isShowOTPComponent && activeTab != 9 && activeTab != 1" class="responsive__save__button">
        <button id="submitButton" :disabled="inProgress" @click="next" class="Layout__Content__Editor__Indicator__Next clickable">
          {{ buttonText }}
        </button>
      </div>
    </div>
    <div v-if="inProgress && !isPreviewMode" class="Toaster">מכין מסמך...</div>
    <div v-if="getInProgress" style="height: 70vh">
      <div class="spinner">
        <div class="double-bounce1"></div>
        <div class="double-bounce2"></div>
      </div>
    </div>
    <OTPComponent v-if="isShowOTPComponent" v-bind:otpDetails="otpDetails" v-bind:token="documentToken"
      v-bind:shortUrl="documentShortUrl" @afterOTP="afterOTPHandler"></OTPComponent>
    <sweet-modal icon="info" ref="documentCancelled" :blocking="true" :hide-close-button="true">
      <p>
        תוקף הקישור פג
        <br />
        ניתן לסגור דף זה!
      </p>
    </sweet-modal>
    <sweet-modal icon="info" ref="alreadySigned" :blocking="true" :hide-close-button="true">
      <p>
        המסמך לא תקף יותר
        <br />
        ניתן לסגור דף זה!
      </p>
    </sweet-modal>
    <sweet-modal icon="success" ref="completed" :blocking="true" :hide-close-button="true">
      <p>
        המסמך מוכן והועבר לשולח.
        <br />
        ישלח אליך מייל עם העתק של הקובץ החתום.
        <br />
        <br />
        ניתן לסגור דף זה!
      </p>
    </sweet-modal>
    <sweet-modal :title="title" ref="modal" :blocking="true" :hide-close-button="true">
      <p style="font-size: 30px">💬</p>
      <p style="font-size: 18px">{{ message }}</p>
      <div style="margin-top: 6px; font-size: 16px;" v-if="documentCount">(מסמך {{ documentNumber }} מתוך {{ documentCount }})</div>
      <template #button>
        <button @click="closeModal()" class="SweetModal__Button center clickable">
          התחל
        </button>
      </template>
    </sweet-modal>
    <sweet-modal title="סיום תהליך" ref="isFinished" :blocking="true" :hide-close-button="true">
      <p style="font-size: 30px">💬</p>
      <p style="font-size: 18px">האם סיימת להעלות את כל המסמכים?</p>
      <template #button>
        <div class="Confirm__Buttons">
          <button @click="sendFiles()" class="SweetModal__Button center clickable">
            כן
          </button>
          <button @click="closeIsFinishedModal()" class="SweetModal__Button center clickable">
            לא
          </button>
        </div>
      </template>
    </sweet-modal>
    <sweet-modal title="שדות נשמרו בהצלחה" ref="previewSaved" :blocking="true" :hide-close-button="true" class="preview-saved-modal">
      <p style="font-size: 30px; margin-bottom: 30px">✅</p>
      <p style="font-size: 18px">השדות נשמרו בהצלחה!</p>
      <template #button>
        <button @click="closePreviewSavedModal()" class="SweetModal__Button center clickable">
          אישור
        </button>
      </template>
    </sweet-modal>
    <sweet-modal class="SignModal" ref="signModal" @close="showSignaturePad = false" :enable-mobile-fullscreen="true">
      <template #default>
        <div class="Signature__Actions">
          <button class="clear" @click="clearSignature">נקה</button>
          <div class="colors">
            <button :class="{ selected: signatureColor === 'blue' }" class="blue"
              @click="signatureColor = 'blue'"></button>
            <button :class="{ selected: signatureColor === 'red' }" class="red" @click="signatureColor = 'red'"></button>
            <button :class="{ selected: signatureColor === 'black' }" class="black"
              @click="signatureColor = 'black'"></button>
            <div class="upload-button">
              <label for="addImageButton" v-if="!background">הוסף חותמת
              </label>
              <button class="remove-stamp" @click="toggleImage" v-if="background">
                הסר חותמת
              </button>
              <input type="file" id="addImageButton" name="addImageButton" accept="image/png, image/jpeg"
                @change="toggleImage" hidden />
            </div>
          </div>
        </div>
        <div style="display: none">
          <img class="Signpad__Component__Background" v-if="background" :src="background" ref="background" alt="" />
        </div>
        <VueSignaturePad v-if="showSignaturePad" :w="'300'" :h="'200'" :sig-option="{ penColor: signatureColor, minWidth: 4 }"
          id="signature" ref="signaturePad" />
        <div class="signature-icon" ref="signatureIcon">
          <img src="@/assets/icons/signature_icon_125x125.png" alt="" />
        </div>
        <p style="font-weight: 800; font-size: 15px">
          <b> יש לחתום מעל הקו </b>
        </p>
        <p>
          בחתימת מסמך זה את/ה מאשר/ת שחתימה אלקטרונית זו זהה לחתימת היד
          המקורית שלך
        </p>
      </template>
      <template #button>
        <div class="SignModal__Buttons">
          <button @click="approveAndSign()" class="SweetModal__Button clickable">
            אישור חתימה
          </button>
          <button @click="closeSignModal()" class="SweetModal__Button clickable flat">
            ביטול
          </button>
        </div>
      </template>
    </sweet-modal>
  </div>
</template>

<script>
// @ is an alias to /src
import DocumentService from "@/services/DocumentService.js";
import OTPComponent from "@/components/OTPComponent";
import { SweetModal } from "sweet-modal-vue";
import VueSignaturePad from "vue-signature";
import img from "../assets/logo.png"
import stampLogo from "../assets/icons/stamp_blue.png"
import UploadRequest from "../components/UploadRequest.vue";
import axios from "axios";

export default {
  name: "LoadForm",
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
    isPreviewMode() {
      return this.$route.path.includes('/preview');
    },
    getUploadAttributes() {
      return this.attributes.filter((a) => a.type === 'upload');
    },
    // hasFilesToUpload() {
    //   return this.attributes.filter((a) => a.type === 'upload' && !a.files.length).length;
    // },
    hasFilesWithoutStatus() {
      return this.attributes.filter((a) => a.type === 'upload' && a.files.filter((f) => f.fileStatus !== 2 && f.fileStatus !== 3)).length;
    },
    hasMessageToSend() {
      return this.attributes.filter((a) => a.type === 'message' && !this.sendToMessage).length;
    },
    buttonText() {
      // Preview mode - always show update template text
      if (this.isPreviewMode) {
        return 'שמור שדות';
      }
      
      // has empty signatues
      if (this.attributes.filter((i) => i.type === 'signature' && !i.isValid && !i.value).length) {
        return 'לחתימה הבאה';
      }
      // has files to upload, go to upload tab
      // else if (this.hasFilesToUpload) {
      //   return this.activeTab === 0 ? 'להעלאת מסמכים' : 'העלה מסמכים';
      // }
      else if (this.hasFilesWithoutStatus) {
        return this.activeTab === 0 ? 'להעלאת מסמכים' : 'שמור ושלח';
      }
      else if (this.hasMessageToSend) {
        return this.activeTab === 1 ? 'הבא' : 'שמור';
      }
      // has next document
      else if (this.nextDocumentRecipient) {
        return 'המשך';
      }
      // finish
      else {
        return 'סיים';
      }
    },
    titleText() {
      if (this.isPreviewMode) {
        return 'תצוגה מקדימה';
      }
      return !this.activeTab ? 'יש לעבור על פרטי המסמך ולמלא את השדות הנדרשים'
        : this.activeTab === 1 ? 'יש להעלות מסמכים' : 'התהליך הסתיים';
    }
  },
  components: {
    SweetModal,
    VueSignaturePad,
    OTPComponent,
    UploadRequest,
  },
  data() {
    return {
      activeAttr: null,
      activeElement: null,
      activeTab: 0,
      attributes: [],
      isFinished: true,
      background: null,
      documentToken: null,
      documentShortUrl: null,
      documentCount: null,
      documentNumber: null,
      images: [],
      img: img,
      stampLogo: stampLogo,
      inProgress: false,
      isDocumentValid: false,
      isOTPRequired: true,
      isShowOTPComponent: false,
      isSingleSign: false,
      hasEmptySignatures: false,
      hasDates: false,
      hasLabels: false,
      hasTextboxes: false,
      hasCheckboxes: false,
      hasAssigneeNames: false,
      getInProgress: false,
      html: null,
      message: null,
      otpDetails: null,
      title: null,
      showSignaturePad: false,
      signedAttributes: [],
      signatureColor: "blue",
      sendToMessage: '',
      signature: null,
      logo: null,
      documentOwner: null,
      nextDocumentRecipient: null,
      isSent: false,
      signedDocumentBlob: null,
      clientName: null,
      isUploadSending: false,
      uploadWasSent: false,
      uploadOwnerData: [],
    };
  },
  async created() {
    axios.defaults.headers.common["x-access-token"] = this.$route.params.accessToken;
    this.documentToken = this.$route.params.token;
    this.documentShortUrl = this.$route.params.id;
    this.isSingleSign = this.$route.query.singleSign;
    this.getDocument();
    DocumentService.getLogo(this.documentShortUrl, this.documentToken)
      .then((res) => {
        if (res && res.data) {
          this.logo = res.data;
        }
      });
  },
  methods: {
    // afterSign() {
    //   if (this.nextDocumentRecipient) {
    //     window.location.reload();
    //   } else {
    //     this.$refs.completed.open();
    //     this.onSignComplete();
    //   }
    // },
    afterOTPHandler() {
      this.otpComponentHandler();
      if (this.loggedIn) {
        this.getDocumentSecure();
      }
    },
    async approveAndSign() {
      const idx = this.attributes.findIndex(
        // eslint-disable-next-line no-underscore-dangle
        (att) => att.x === this.activeAttr.x && att.y === this.activeAttr.y
      );
      if (this.$refs.signaturePad.isEmpty() && !this.background) {
        console.log("empty");
        this.activeAttr.isValid = false;
        this.activeAttr.signature = null;
      } else {
        const self = this;
        const canvas = document.getElementById("canvas");
        const data = canvas.toDataURL();

        const base64 = await new Promise((resolve) => {
          const canvas = document.createElement("canvas");
          canvas.width = self.attributes[idx].width;
          canvas.height = self.attributes[idx].height;
          const ctx = canvas.getContext("2d");
          const imageObj1 = new Image();
          const imageObj2 = new Image();
          if (self.background) {
            imageObj1.src = self.background;

            imageObj1.onload = function () {
              const ratioHight = canvas.height / self.$refs.background.height;
              const ratioWidth = canvas.width / self.$refs.background.width;
              let ratio = 1;
              let widthFromLeft = 0;
              let heightFromTop = 0;
              if (ratioWidth > ratioHight) {
                ratio = ratioHight;
                widthFromLeft =
                  (canvas.width - self.$refs.background.width * ratio) / 2;
              } else {
                ratio = ratioWidth;
                heightFromTop =
                  (canvas.height - self.$refs.background.height * ratio) / 2;
              }
              ctx.drawImage(
                imageObj1,
                widthFromLeft,
                heightFromTop,
                self.$refs.background.width * ratio,
                self.$refs.background.height * ratio
              );
              document.body.append(canvas);
              imageObj2.src = data;
              imageObj2.onload = function () {
                ctx.drawImage(imageObj2, 0, 0, canvas.width, canvas.height);
                const img = canvas.toDataURL("png");
                resolve(img);
              };
            };
          } else {
            imageObj2.src = data;
            imageObj2.onload = function () {
              ctx.drawImage(imageObj2, 0, 0, canvas.width, canvas.height);
              const img = canvas.toDataURL("png");
              resolve(img);
            };
          }
        });
        this.showSignaturePad = false;
        this.activeElement.style.backgroundImage = `url(${base64})`;
        this.activeElement.classList.remove("focused");
        this.activeAttr.isValid = true;
        this.activeElement = null;
        this.$refs.signModal.close();
        this.background = null;
        this.activeAttr.signature = base64;
        // this.hasEmptySignatures = this.attributes.filter((i) => i.type === 'signature' && !i.isValid).length > 0;
        
        this.signature = base64;
      }

      this.checkIsDocumentValid();
      this.attributes.splice(idx, 1, this.activeAttr);
    },
    clearSignature() {
      this.$refs.signaturePad.clear();
    },
    saveFile(attr) {
      attr.isValid = true;
      attr.fileDocumentStatus = 1;
      const idx = this.attributes.findIndex((att) => att.fileDocumentType === attr.fileDocumentType);
      this.attributes.splice(idx, 1, attr);
      this.checkIsDocumentValid();
    },
    deleteFile(attr) {
      // DocumentService.deleteFile(this.documentShortUrl, this.documentToken, fileGuid)
      //   .then((res) => {
      //     console.log(res);
      //   })
      attr.fileDocumentStatus = 0;
      this.checkIsDocumentValid();
    },
    closeModal() {
      this.$refs.modal.close();
      if (this.loggedIn || !this.otpDetails || !this.otpDetails.otpRequired) {
        this.goToNextField();
      }
      else {
        this.otpComponentHandler();
      }
    },
    sendFiles() {
      this.isFinished = true;
      this.$refs.isFinished.close();
      this.finish();
      this.onSignComplete();
    },
    async onUploadSend(ownerData) {
      this.uploadOwnerData = ownerData || [];
      this.isUploadSending = true;
      this.isFinished = false;
      await this.finish();
      this.uploadWasSent = true;
      this.isUploadSending = false;
    },
    async onUploadFinish(ownerData) {
      this.uploadOwnerData = ownerData || [];
      this.isUploadSending = true;
      this.isFinished = true;
      await this.finish();
      this.isUploadSending = false;
      this.onSignComplete();
    },
    async closeIsFinishedModal() {
      this.isFinished = false;
      this.$refs.isFinished.close();
      await this.finish();
      // window.location.reload();
      // this.$refs.finishedUploadAttributes.open();
      this.onSignComplete();
    },
    closeSignModal() {
      this.showSignaturePad = false;
      this.$refs.signModal.close();
    },
    closePreviewSavedModal() {
      this.$refs.previewSaved.close();
    },
    checkIsDocumentValid() {
      if (this.isPreviewMode) {
        // In preview mode, we only care about non-signature attributes being valid
        // Signatures are not required in preview mode
        const nonSignatureAttributes = this.attributes.filter((a) => a.type !== 'signature');
        this.isDocumentValid = nonSignatureAttributes.length === 0 || 
          nonSignatureAttributes.filter((a) => a.isValid).length === nonSignatureAttributes.length;
      } else {
        // Normal mode - validate all attributes including signatures
        this.isDocumentValid =
          this.attributes.filter((a) => a.isValid).length ===
          this.attributes.length;
      }
    },
    complete() {
      this.$ref.completed.close();
    },
    documentErrorHandler(err) {
      if (err.response && err.response.data) {
        if ((err.response.data.errorCode === 14 ||
          err.response.data.errorCode === '14') && err.response.data.link) {
          window.location.href = err.response.data.link;
        }
        if (err.response.data.errorCode === 4 ||
          err.response.data.errorCode === '4') {
          this.$refs.alreadySigned.open();
        }
        if (err.response.data.errorCode === 8 ||
          err.response.data.errorCode === '8') {
          this.$refs.documentCancelled.open();
        }
      }
    },
    documentResponseHandler(res) {
      // const newAttributes = [
        // {
        //   assignee: null,
        //   fileDocumentType: 'AF1',
        //   files: [],
        //   type: 'upload',
        //   value: null
        // },
        // {
        //   assignee: null,
        //   fileDocumentType: 'AF1124',
        //   files: [],
        //   type: 'upload',
        //   value: null
        // },
        // {
        //   assignee: null,
        //   fileDocumentType: 'AF14214',
        //   files: [],
        //   type: 'upload',
        //   value: null
        // },
        // {
        //   assignee: null,
        //   fileDocumentType: 'AF14125',
        //   files: [],
        //   type: 'upload',
        //   value: null
        // },
        // {
        //   assignee: null,
        //   fileDocumentType: 'AF13124',
        //   files: [],
        //   type: 'upload',
        //   value: null
        // },
        // {
        //   assignee: null,
        //   fileDocumentType: 'AF1254',
        //   files: [],
        //   type: 'upload',
        //   value: null
        // },
        // {
        //   assignee: null,
        //   fileDocumentType: 'AF1554',
        //   files: [],
        //   type: 'upload',
        //   value: null
        // },
        // {
        //   assignee: null,
        //   fileDocumentType: 'AF789814',
        //   files: [],
        //   type: 'upload',
        //   value: null
        // },
        // {
        //   assignee: null,
        //   fileDocumentType: 'AF1234',
        //   files: [],
        //   type: 'upload',
        //   value: null
        // },
        // {
        //   assignee: null,
        //   fileDocumentType: 'AF1414',
        //   files: [],
        //   type: 'upload',
        //   value: null
        // },
      //   {
      //     assignee: null,
      //     fileDocumentType: 'SS1',
      //     files: [],
      //     type: 'message',
      //     value: null
      //   },
      // ];
      // res.data.attributes = res.data.attributes.concat(newAttributes);
      // res.data.html = "<div style='display: flex; flex-direction: column;'><div style='display: flex; flex-direction: column; align-items: flex-start; margin-bottom: 30px' class='to'><p style='font-weight: bold'>לכבוד</p><p>אא בדיקות אא</p><p>ת.ז 061297339</p></div><div class='message-container'><div class='message-title' style='margin-bottom: 20px'><h1 style='font-weight: bold;'>הנדון: <span style='text-decoration: underline;'>השלמות לצורך ביקורת והכנת הדוח השנתי</span></h1></div><div class='message-section' style='text-align: right'><p style='margin-bottom: 15px'>לצורך הכנת הדוח השנתי האישי לשנת 2022, יש להמציא, עבור שני בני הזוג והילדים אשר טרם מלאו להם 18, את האישורים והמסמכים כדלקמן:</p><ul style='list-style: auto; margin: 0 30px'><li>במידה והנך עוסק פטור במע''מ, יש להמציא אסמכתאות להכנסות שלך בשנת 2022 (חשבונות קבלה שהוצאת בשנת 2022).</li><li>במידה והנך מוציא חשבוניות ממוחשבות, נא להמציא אישור על סך ההכנסות שהיו בשנת 2022, ודוח רציפות אסמכתאות לשנת 2022.</li><li>טפסי 106 של שני בני הזוג, ו/או תלושי משכורת אחד מכל המעבידים של שני בני הזוג בשנת 2022.</li><li>ספירת מלאי ליום 31/12/2022.</li><li>אישור על ניכוי מס במקור מכל הבנקים (טפסי867) לשנת 2022.</li><li>אישור על ניכוי מס במקור (טופס 857 מהלקוחות שניכו מס במקור) לשנת 2022.</li><li>אישור לצורך מס לשנת 2022 מכל חברות הביטוח, בגין ביטוחים אישיים, כגון: פנסיה, קרן השתלמות, ביטוחי חיים וכו'.</li><li>אסמכתאות להכנסות משכירות (חוזי שכירות) ו/או הכנסות אחרות בשנת 2022.</li><li>אסמכתאות ואישורים רלוונטיים להכנסות מחו''ל בשנת 2022.</li><li>קבלות מקוריות של תרומות שנתרמו בשנת.</li><li>צילום ת.ז כולל הספח.</li><li>רישיונות ופוליסות ביטוחי רכבים לשנת 2022 (חובה ומקיף) אשר שימשו את העסק.</li><li>במידה ומכרת או רכשת רכבים בשנת 2022 נא להמציא זיכרון דברים בגין המכירה או הרכישה.</li><li>במידה והנך מתגורר בישוב אשר מזכה בהנחת מס, נא להמציא אישור תושבות.</li><li>במידה וקיימים הכנסות והוצאות נוספות, אשר לא פורטו לעיל, נא לצרפם למסמכים.</li></ul><p style='margin-top: 15px; font-weight: bold'>הערות:</p><ul style='list-style: hebrew; margin: 0 30px'><li>במידה וחלק מהסעיפים דלעיל אינם רלוונטיים עבורך, נא לציין ל.ר לצד אותו סעיף.</li><li>יתכן וידרשו לנו מסמכים נוספים.</li><li>לידיעתך, עיכוב בהכנת והמצאת המסמכים הנ''ל, עלול לגרור חיוב בריבית פיגורים וקנסות.</li></ul></div><div class='honor' style='margin-right: 50%; text-align: right; margin-top: 20px'><p style='font-weight: bold;'>בכבוד רב</p><p>זחבטוב אנדרי</p><p>אנגולראי, יועץ מס, VBS, סי שרפאי, טבלאי, בלש</p></div></div></div>"
      const doc = res.data;

      this.otpDetails = doc.otpDetails;
      this.nextDocumentRecipient = doc.nextDocumentRecipient;
      this.html = doc.html;

      this.documentCount = doc.documentCount;
      this.documentNumber = doc.documentNumber;
      this.documentOwner = doc.documentOwner;
      this.clientName = doc.clientName || doc.assigneeName || null;
      console.log(this.documentNumber);

      if (this.otpDetails && this.otpDetails.otpRequired) {
        if (this.loggedIn) {
          this.getDocumentSecure(true);
          return;
        }
        else {
          this.title = doc.title;
          this.message = doc.message ? doc.message : this.attributes.filter((i) => i.type === 'signature' && !i.isValid && !i.value).length ? 'נא לחתום על המסמך' : 'נא להעלות מסמכים';
          this.mobileStyleHandler();
          // this.$refs.modal.open();
          if (this.loggedIn || !this.otpDetails || !this.otpDetails.otpRequired) {
            this.goToNextField();
          }
          else {
            this.otpComponentHandler();
          }
        }
      }
      else {
        this.images = doc.images;
        this.attributes = doc.attributes;
        this.signedAttributes = doc.pastSignedAttributes;

        // Initialize checkbox values based on isChecked property from server
        this.initializeCheckboxValues();

        this.hasEmptySignatures = this.attributes.filter((i) => i.type === 'signature' && !i.value).length > 0;
        this.hasDates = this.attributes.filter((i) => i.type === 'signatureDate').length > 0;
        this.hasLabels = this.attributes.filter((i) => i.type === 'label').length > 0;
        this.hasTextboxes = this.attributes.filter((i) => i.type === 'textbox').length > 0;
        this.hasCheckboxes = this.attributes.filter((i) => i.type === 'checkbox').length > 0;
        this.hasAssigneeNames = this.attributes.filter((i) => i.type === 'assigneeName').length > 0;

        this.title = doc.title;
        this.message = doc.message ? doc.message : this.attributes.filter((i) => i.type === 'signature' && !i.isValid && !i.value).length ? 'נא לחתום על המסמך' : 'נא להעלות מסמכים';
        this.mobileStyleHandler();
        // Don't show modal in preview mode
        if (!this.isPreviewMode) {
          this.$refs.modal.open();
        }
        if (this.loggedIn || !this.otpDetails || !this.otpDetails.otpRequired) {
            this.goToNextField();
          }
          else {
            this.otpComponentHandler();
          }
      }
    },
    documentSecureResponseHandler(res) {
      // res.data.html = '<div><h1>Hello</h1></div>';
      // res.data.attributes.push({
      //     assignee: null,
      //   height: 100,
      //   page: 1,
      //   fileDocumentName: 'טופס 106',
      //   fileDocumentType: 106,
      //   fileDocumentOwner: 1,
      //   fileDocumentStatus: 1,
      //   required: false,
      //   files: [{
      //     fileName: 'asd',
      //     fileGuid: 'asdasdasdasdas'
      //   }],
      //   type: "upload",
      //   value: null,
      //   // width: 200,
      //   // x: 307,
      //   // y: 447
      // })
      // res.data.attributes.push({
      //   assignee: null,
      //   height: 100,
      //   page: 1,
      //   fileDocumentName: 'טופס 106',
      //   fileDocumentType: 106,
      //   fileDocumentOwner: 1,
      //   fileDocumentStatus: 1,
      //   required: false,
      //   files: [{
      //     fileName: 'asd',
      //     fileGuid: 'asdasdasdasdas'
      //   }],
      //   type: "upload",
      //   value: null,
      //   // width: 200,
      //   // x: 307,
      //   // y: 447
      // },{
      //   assignee: null,
      //   height: 100,
      //   page: 1,
      //   fileDocumentName: 'טופס 105',
      //   fileDocumentType: 106,
      //   fileDocumentOwner: 2,
      //   fileDocumentStatus: 0,
      //   required: false,
      //   type: "upload",
      //   value: null,
      //   // width: 200,
      //   // x: 307,
      //   // y: 447
      // },{
      //   assignee: null,
      //   height: 100,
      //   page: 1,
      //   fileDocumentName: 'טופס 102',
      //   fileDocumentType: 106,
      //   fileDocumentOwner: 3,
      //   fileDocumentStatus: 2,
      //   required: false,
      //   type: "upload",
      //   value: null,
      //   // width: 200,
      //   // x: 307,
      //   // y: 447
      // },{
      //   assignee: null,
      //   height: 100,
      //   page: 1,
      //   fileDocumentName: 'טופס 101',
      //   fileDocumentType: 106,
      //   fileDocumentOwner: 1,
      //   fileDocumentStatus: 0,
      //   required: false,
      //   type: "upload",
      //   value: null,
      //   // width: 200,
      //   // x: 307,
      //   // y: 447
      // });
      const doc = res.data;

      this.documentCount = doc.documentCount;
      this.documentNumber = doc.documentNumber;
      this.documentOwner = doc.documentOwner;
      this.clientName = doc.clientName || doc.assigneeName || null;
      // doc.attributes = [
      //   {
      //     assignee: null,
      //     assigneeNumber: 1,
      //     height: 100,
      //     page: 1,
      //     required: false,
      //     type: 'signature',
      //     value: null,
      //     width: 150,
      //     x: 623,
      //     y: 298
      //   },
      //   {
      //     assignee: null,
      //     assigneeNumber: 1,
      //     height: 40,
      //     page: 1,
      //     required: false,
      //     type: 'signatureDate',
      //     value: new Date(),
      //     width: 150,
      //     x: 10,
      //     y: 350
      //   },
      //   {
      //     assignee: null,
      //     assigneeNumber: 1,
      //     height: 40,
      //     page: 1,
      //     required: false,
      //     type: 'assigneeName',
      //     value: 'Yossi Yossef',
      //     width: 150,
      //     x: 100,
      //     y: 550
      //   }
      // ]

      this.images = doc.images;
      this.html = doc.html;
      this.attributes = doc.attributes;
      
      // Initialize checkbox values based on isChecked property from server
      this.initializeCheckboxValues();
      
      this.hasEmptySignatures = this.attributes.filter((i) => i.type === 'signature' && !i.value).length > 0;
      this.hasDates = this.attributes.filter((i) => i.type === 'signatureDate').length > 0;
      this.hasLabels = this.attributes.filter((i) => i.type === 'label').length > 0;
      this.hasTextboxes = this.attributes.filter((i) => i.type === 'textbox').length > 0;
      this.hasCheckboxes = this.attributes.filter((i) => i.type === 'checkbox').length > 0;
      this.hasAssigneeNames = this.attributes.filter((i) => i.type === 'assigneeName').length > 0;
      this.signedAttributes = doc.pastSignedAttributes;
      this.title = doc.title;
      this.message = doc.message ? doc.message : this.attributes.filter((i) => i.type === 'signature' && !i.isValid && !i.value).length ? 'נא לחתום על המסמך' : 'נא להעלות מסמכים';
      this.nextDocumentRecipient = doc.nextDocumentRecipient;

      this.mobileStyleHandler();

      // Don't show modal in preview mode
      if (!this.isPreviewMode) {
        this.$refs.modal.open();
      }
    },
    async finish() {
      this.inProgress = true;
      if (this.otpDetails && this.otpDetails.otpRequired) {
        await this.signDocumentSecure();
      }
      else {
        await this.signDocument();
      }
      this.signedDocumentBlob = null;
      this.hasEmptySignatures = false;
      this.hasDates = false;
      this.hasLabels = false;
      this.hasTextboxes = false;
      this.hasCheckboxes = false;
      this.hasAssigneeNames = false;
    },
    getAttributes(page = 1) {
      if (this.isPreviewMode) {
        // In preview mode, show all signature attributes from all assignees
        return this.attributes.filter((a) => a.page === page && a.type === 'signature');
      }
      // Normal mode - filter by assignee number (original logic)
      return this.attributes.filter((a) => a.page === page && a.type === 'signature');
    },
    getDatesAttributes(page = 1) {
      if (this.isPreviewMode) {
        // In preview mode, show all date attributes from all assignees
        return this.attributes.filter((a) => a.page === page && a.type === 'signatureDate');
      }
      // Normal mode - filter by assignee number (original logic)
      return this.attributes.filter((a) => a.page === page && a.type === 'signatureDate');
    },
    getAssigneeNameAttributes(page = 1) {
      if (this.isPreviewMode) {
        // In preview mode, show all assignee name attributes from all assignees
        return this.attributes.filter((a) => a.page === page && a.type === 'assigneeName');
      }
      // Normal mode - filter by assignee number (original logic)
      return this.attributes.filter((a) => a.page === page && a.type === 'assigneeName');
    },

    getLabelAttributes(page = 1) {
      if (this.isPreviewMode) {
        // In preview mode, show all label attributes from all assignees
        return this.attributes.filter((a) => a.page === page && a.type === 'label');
      }
      // Normal mode - filter by assignee number (original logic)
      return this.attributes.filter((a) => a.page === page && a.type === 'label');
    },
    
    getTextboxAttributes(page = 1) {
      if (this.isPreviewMode) {
        // In preview mode, show all textbox attributes from all assignees
        return this.attributes.filter((a) => a.page === page && a.type === 'textbox');
      }
      // Normal mode - filter by assignee number (original logic)
      return this.attributes.filter((a) => a.page === page && a.type === 'textbox');
    },
    
    getCheckboxAttributes(page = 1) {
      if (this.isPreviewMode) {
        // In preview mode, show all checkbox attributes from all assignees
        return this.attributes.filter((a) => a.page === page && a.type === 'checkbox');
      }
      // Normal mode - filter by assignee number (original logic)
      return this.attributes.filter((a) => a.page === page && a.type === 'checkbox');
    },

    initializeCheckboxValues() {
      // Initialize checkbox values based on isChecked property from server
      this.attributes.forEach(attr => {
        if (attr.type === 'checkbox') {
          console.log('Initializing checkbox:', attr);
          // Ensure isChecked is a boolean, handling various input types
          if (typeof attr.isChecked === 'string') {
            attr.isChecked = attr.isChecked.toLowerCase() === 'true' || attr.isChecked === '1';
          } else if (typeof attr.isChecked === 'number') {
            attr.isChecked = attr.isChecked === 1;
          } else {
            attr.isChecked = Boolean(attr.isChecked);
          }
          // Set the value to match the checked state
          attr.value = attr.isChecked;
          
          // For required checkboxes, mark as valid if they have a value
          if (attr.required && attr.value !== null && attr.value !== undefined) {
            attr.isValid = true;
          }
          console.log('Checkbox after initialization:', attr);
        }
      });
    },

    getDocument() {
      if (!this.getInProgress) {
        this.getInProgress = true;
        
        if (this.isPreviewMode) {
          // In preview mode, use the preview endpoint
          DocumentService.getPreview(this.documentShortUrl)
            .then(this.documentResponseHandler)
            .catch(this.documentErrorHandler)
            .finally(() => {
              this.getInProgress = false;
            });
        } else {
          // Normal mode - use the regular document endpoint
          DocumentService.get(this.documentShortUrl, this.documentToken, this.isSingleSign)
            .then(this.documentResponseHandler)
            .catch(this.documentErrorHandler)
            .finally(() => {
              setTimeout(() => {
                this.getInProgress = false;
              }, 500);
            });
        }
      }
    },
    getDocumentSecure(isForce) {
      if (!this.getInProgress || isForce) {
        this.getInProgress = true;
        
        if (this.isPreviewMode) {
          // In preview mode, use the preview endpoint
          DocumentService.getPreview(this.documentShortUrl)
            .then(this.documentSecureResponseHandler)
            .catch(this.documentErrorHandler)
            .finally(() => {
              this.getInProgress = false;
            });
        } else {
          // Normal mode - use the secure endpoint
          DocumentService.getSecure(this.documentShortUrl, this.documentToken)
            .then(this.documentSecureResponseHandler)
            .catch(this.documentErrorHandler)
            .finally(() => {
              setTimeout(() => {
                this.getInProgress = false;
              }, 500);
            });
        }
      }
    },
    getSignedAttributes(page = 1) {
      if (!this.signedAttributes) return [];
      return this.signedAttributes.filter((a) => a.page === page);
    },
    goToNextField() {

      // if (this.getUploadAttributes.length && this.activeAttr && this.activeAttr.signature) {
      //   this.activeTab = 1;
      // }


      const attributes = window.document.querySelectorAll(
        ".Layout__Content__Page__Attributes__Item:not(.valid)"
      );

      if (this.activeElement) {
        let index = Array.from(attributes).indexOf(this.activeElement);
        if (index > -1) {
          if (index < attributes.length - 1) {
            // eslint-disable-next-line no-plusplus
            this.activeElement = attributes[index++];
          }
        }
      }
      // eslint-disable-next-line prefer-destructuring
      this.activeElement = attributes[0];

      if (this.activeElement) {
        this.activeElement.scrollIntoView({
          behavior: "smooth",
          block: "end",
          inline: "nearest",
        });
        this.activeElement.classList.add("focused");
      }

    },
    isMobile() {
      return window.innerWidth <= 800 || window.innerHeight <= 600;
    },
    mobileStyleHandler() {
      if (this.isMobile()) {
        setTimeout(() => {
          window.document.body.classList.add("mobile");
          const width = window.screen.availWidth - 15;
          const elem = this.$refs.editor;
          elem.style.transform = `translate3d(0px, 0px, 0px)`;
          elem.style.transform += `scale3d(${width / 793}, ${width / 793
            }, 1)`;
          this.$refs.container.style.height = "100vh";
          this.$refs.signatureIcon.style.display = "none";
        });
      }
    },
    next() {
      // Preview mode - always call updatePreview
      if (this.isPreviewMode) {
        this.inProgress = true;
        this.updatePreview();
        return;
      }
      
      // has empty signatues
      if (this.hasEmptySignatures) {
        // is empty signature, go to next signature
        if (this.attributes.filter((a) => a.type === 'signature' && !a.isValid).length) {
          this.goToNextField();
        }
        else {
          // all signatures added, save them
          this.inProgress = true;
          const signPromise = this.otpDetails && this.otpDetails.otpRequired ? this.signDocumentSecure() : this.signDocument();
          signPromise.then(() => {
            this.hasEmptySignatures = false;
            this.inProgress = false;
            this.isSent = true;
            this.next()
          });
          // this.hasEmptySignatures = false;
          // this.next();
        }
      }
      // has files to upload, go to upload tab
      // else if (this.hasFilesToUpload) {
      //   this.activeTab = 1;
      //   if (this.isMobile) {
      //     this.$refs.container.style.height = "calc(100vh - 150px)";
      //   }
      // }
      else if (this.hasFilesWithoutStatus && this.activeTab != 1) {
        this.activeTab = 1;
        if (this.isMobile) {
          this.$refs.container.style.height = "calc(100vh - 150px)";
        }
      }
      else if (this.attributes.every((a) => a.type === "upload" && a.files.every((f) => f.fileStatus != 1))) {
        return
      }
      else if (this.activeTab === 1) {
        this.$refs.isFinished.open();
      }
      else if (this.hasMessageToSend) {
        this.activeTab = 2;
      }
      // has next document
      else if (this.nextDocumentRecipient) {
        window.location.reload();
      }
      // finish
      else if (!this.isSent) {
        this.finish();
        this.onSignComplete();
      } else {
        this.onSignComplete();
      }
    },
    onAttributeClick(e, attr) {
      const element = e.target;
      this.activeAttr = attr;
      this.activeElement = element;
      if (attr.type === "signature") {
        this.openSignModal();
      }
    },
    
    onTextboxInput(attr) {
      // Mark the textbox as valid when user starts typing
      if (attr.value && attr.value.trim()) {
        attr.isValid = true;
      } else {
        attr.isValid = false;
      }
      this.checkIsDocumentValid();
    },
    
    onCheckboxChange(event, attr) {
      console.log('Checkbox change event:', attr);
      // Mark the checkbox as valid when user changes it
      attr.isValid = true;
      
      // Get the current checkbox state from the DOM element
      const checkbox = event.target;
      const isChecked = checkbox.checked;
      
      // Update the isChecked property and value
      attr.isChecked = isChecked;
      attr.value = isChecked;
      
      // For required checkboxes, ensure they are marked as valid
      if (attr.required) {
        attr.isValid = true;
      }
      
      console.log('Checkbox after change:', attr);
      this.checkIsDocumentValid();
    },
    openSignModal() {
      this.showSignaturePad = true;
      this.$refs.signModal.open();
    },
    otpComponentHandler() {
      if (this.otpDetails && this.otpDetails.otpRequired && !this.loggedIn) {
        this.isShowOTPComponent = true;
      }
      else {
        this.isShowOTPComponent = false;
      }
    },
    signDocument() {
      return DocumentService.sign(this.documentShortUrl, this.documentToken, this.isFinished, {
        signatures: this.attributes
          .filter((a) => a.type === 'signature' && a.signature)
          .map((a) => ({
            value: a.signature,
            x: a.x,
            y: a.y
          })),
        checkboxes: this.attributes
          .filter((a) => a.type === 'checkbox')
          .map((a) => ({
            value: a.isChecked ? "1" : "0",
            x: a.x,
            y: a.y
          })),
        textboxes: this.attributes
          .filter((a) => a.type === 'textbox')
          .map((a) => ({
            value: a.value || "",
            x: a.x,
            y: a.y
          })),
        uploads: this.uploadOwnerData,
      })
        .finally(() => {
          this.inProgress = false;
          // this.$refs.completed.open();
        });
    },
    signDocumentSecure() {
      return DocumentService.signSecure(this.documentShortUrl, this.documentToken, this.isFinished, {
        signatures: this.attributes
          .filter((a) => a.type === 'signature' && a.signature)
          .map((a) => ({
            value: a.signature,
            x: a.x,
            y: a.y
          })),
        checkboxes: this.attributes
          .filter((a) => a.type === 'checkbox')
          .map((a) => ({
            value: a.isChecked ? "1" : "0",
            x: a.x,
            y: a.y
          })),
        textboxes: this.attributes
          .filter((a) => a.type === 'textbox')
          .map((a) => ({
            value: a.value || "",
            x: a.x,
            y: a.y
          })),
        uploads: this.uploadOwnerData,
      })
        .finally(() => {
          this.inProgress = false;
          // this.$refs.completed.open();
        });
    },
    toggleImage(e) {
      if (this.background) {
        return (this.background = null);
      }
      const file = e.target.files[0];
      const self = this;
      const reader = new FileReader();
      reader.onload = function (e) {
        self.background = e.target.result;
        document.getElementById(
          "signature"
        ).style.background = `#f3f3f3 url('${e.target.result}') no-repeat center `;
        document.getElementById("addImageButton").value = "";
      };
      reader.onerror = function () { };
      reader.readAsDataURL(file);
    },
    updatePreview() {
      // In preview mode, send the same data structure but to updatePreview endpoint
      return DocumentService.updatePreview(this.documentShortUrl, {
        signatures: this.attributes
          .filter((a) => a.type === 'signature' && a.signature)
          .map((a) => ({
            value: a.signature,
            x: a.x,
            y: a.y
          })),
        checkboxes: this.attributes
          .filter((a) => a.type === 'checkbox')
          .map((a) => ({
            value: a.isChecked ? "1" : "0",
            x: a.x,
            y: a.y
          })),
        textboxes: this.attributes
          .filter((a) => a.type === 'textbox')
          .map((a) => ({
            value: a.value || "",
            x: a.x,
            y: a.y
          })),
        // uploads: this.attributes.filter((a) => a.type === "upload"),
      })
        .then(() => {
          this.inProgress = false;
          window.parent.postMessage('ok', "*");
          this.$refs.previewSaved.open();
        })
        .catch((error) => {
          console.error('Error saving preview:', error);
          this.inProgress = false;
        });
    },
    onSignComplete() {
      window.parent.postMessage('ok', "*");
      window.parent.postMessage(this.$route.params.token, "*");
      this.activeTab = 9;
      // this.$refs.completed.open();
      this.pollSignedFile();
    },
    async pollSignedFile() {
      try {
        const response = await DocumentService.getSignedFile(this.documentShortUrl, this.documentToken);
        if (response.status === 200) {
          this.signedDocumentBlob = response.data;
        } else if (response.status === 202) {
          this.pollSignedFile();
        }
      } catch {
        // silent — download link simply won't appear
      }
    },
    downloadSignedDocument() {
      const url = URL.createObjectURL(this.signedDocumentBlob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'signed-document.pdf';
      a.click();
      URL.revokeObjectURL(url);
    },
    getBackgroundColor(assigneeNumber, fieldType = null) {
      // Special case: label, textbox, and checkbox fields from client details button should be teal
      if (assigneeNumber === 1 && (fieldType === 'label' || fieldType === 'textbox' || fieldType === 'checkbox')) return 'teal';
      if (assigneeNumber === 1) return 'ochre';
      if (assigneeNumber === 2) return 'light-gray';
      if (assigneeNumber === 99) return 'teal';
      return 'light-blue';
    }
  },
};
</script>
<style scoped lang="scss">
.disabled {
  cursor: no-drop;
  opacity: 0.5;
  pointer-events: none;
}

::v-deep .Signature__Actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: unset !important;
  top: unset !important;
  left: unset !important;
  width: 90%;
  margin: 0 auto;
  transform: unset !important;
  z-index: 3;
}

.responsive__save__button {
  width: 100%;
  margin: 0 auto;
  position: fixed;
  bottom: 5px;
  background: #ffffffcc;
  box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.18);
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  button {
    width: 50%;
    max-width: 250px;
    background: #137fec;
    color: white;
    border: none;
    height: 40px;
    padding: 5px 10px;
    min-width: 110px;
    font-size: 15px;
    font-weight: 700;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(19, 127, 236, 0.25);
    cursor: pointer;
  }
}

#signature {
  position: relative;
  // height: 300px;
  height: 250px;
  height: 200px;
  overflow: hidden;
}

#signature:after {
  content: "";
  width: 100%;
  left: 0;
  height: 1px;
  position: absolute;
  bottom: 0%;
  background: #cecece;
  z-index: 2;
  pointer-events: none;
}

.Layout {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}

.Layout__Content__Sidemenu {
  display: flex;
  background: white;
  width: 364px;
  height: 100%;
}

.Layout__Navbar {
  flex: 0 0 auto;
  background: white;
  width: 100%;
  height: 55px;
  display: flex;
  justify-content: start;
  border-bottom: 1px solid #dedede;
  align-items: center;
  z-index: 3;

  .Layout__Navbar__Logo {
    max-width: 90px;
    margin-right: 10px;

    img {
      max-width: 100%;
      display: block;
      max-height: 40px;
    }
  }

  .Layout__Navbar__Title {
    text-align: center;
    width: 100%;
    font-weight: bold;
    position: absolute;
  }
}

.Layout__Navbar__Footer {
  height: 40px;
  background: #2d6690;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
}

.Layout__Content__Editor__Indicator {
  background: #f4f4f4;
  display: flex;
  height: 40px;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 0px 3px #00000030;
  position: sticky;
  z-index: 2;
  top: 0;

  .Layout__Content__Editor__Indicator__Next:disabled {
    opacity: 0.3;
    pointer-events: none;
  }

  div {
    padding: 0 5px;
    width: 793px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;

    span {
      font-size: 15px;
    }

    button {
      background: #137fec;
      color: white;
      border: none;
      height: 40px;
      padding: 5px 10px;
      min-width: 110px;
      font-size: 15px;
      font-weight: 700;
      border-radius: 8px;
      box-shadow: 0 2px 8px rgba(19, 127, 236, 0.25);
      cursor: pointer;
    }
  }
}

.Layout__Content {
  display: flex;
  position: relative;
  // background: #efedec;
  background: #f7f7f7;
  border-bottom: 1px solid rgb(228, 228, 228);
  height: calc(100vh - 95px);
  overflow-y: auto;

  .Layout__Content__Editor {
    display: flex;
    justify-content: center;
    flex-direction: column;
    justify-content: start;
    align-items: center;
    padding: 15px;
    box-sizing: border-box;

    height: 100%;
    width: 100%;
    .success {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 10px;
      height: 50%;
      width: 50%;
      justify-content: center;
      background-color: white;
      .success-image {

        img {
          max-width: 100%;
          display: block;
          max-height: 110px;
        }
      }
      .success-date {
        display: flex;
        align-items: center;
        gap: 10px;
      }
      .success-title {
        font-size: 1.25rem;
        font-weight: bold;
      }
      .success-message {
        text-align: right;
      }
      span {
        color: #118dcf;
      }
      .success-download {
        margin-top: 30px;
        p {
          font-size: 0.85rem;
          color: #333;
        }
        .success-download-preparing {
          color: #888;
          font-style: italic;
        }
        .download-link {
          color: #137fec;
          text-decoration: underline;
          cursor: pointer;
          font-size: inherit;
          font-weight: inherit;
          &:hover {
            color: #0a5aad;
          }
        }
      }
    }

    .rtl {
      direction: rtl !important;
    }

    .html {
      padding: 15px;
      line-height: 19px;
    }

    .message-section {
      width: 50%;
    }

    .upload-tab-content {
      padding: 0 !important;
      background: transparent;
      align-items: stretch !important;
      overflow-y: auto;
    }

  &.upload-bg {
    background: linear-gradient(180deg, #FAFAF7 0%, #F4F5F7 100%);
  }

    .upload-section {
      width: 50%;

      .title {
        width: 100%;
        height: 80px;
        margin: 0 auto;
        display: flex;
        text-align: right;
        gap: 14px;
      }

      .uploads {
        display: grid;
        // background-color: #fff;
        gap: 15px;
        grid-template-columns: repeat(2, 1fr);
        margin-bottom: 60px;
      }

      .full-width {
        grid-template-columns: auto !important;
        width: 50%;
        margin: 0 auto;
      }
    }

    .send-to-container {
      display: flex;
      align-items: flex-start;
      flex-direction: column;
      gap: 10px;
      margin-top: 10px;

      h1 {
        font-size: 20px;
        font-weight: bold;
      }

      textarea {
        width: 100%;
        font-family: "Varela Round", "Open Sans", "Helvetica Neue", Arial, sans-serif;
        font-size: 16px;
      }
    }

    .Layout__Content__Page {
      width: 793px;
      background: white;
      display: flex;
      margin: 15px 0 65px 0;
      box-shadow: 0 5px 5px rgba(0, 0, 0, 0.15);
      position: relative;
      direction: ltr;
      // height: 1122px;

      img {
        width: 100%;
      }

      .Layout__Content__Page__Attributes {
        width: 100%;
        height: 100%;
        position: absolute;

        .Layout__Content__Page__Attributes__Custom__Item {
          display: flex;
          justify-content: center;
          align-items: center;
          font-weight: bold;
          font-size: 12px;
          z-index: 100;
          text-align: center;
          padding: 0;
          border: 2px dashed #137fec;
          background: rgba(19, 127, 236, 0.1);
          border-radius: 5px;
          color: #137fec;
          transition: box-shadow 0.2s ease;

          &.type-label,
          &.type-signatureDate,
          &.type-assigneeName {
            justify-content: flex-end;
            text-align: right;
            padding-right: 5px;
            color: #000000;
            font-size: 12px;
          }

          &.valid {
            box-shadow: 0 0 0 1.5px #34d399;
          }

          &.required:not(.valid) {
            box-shadow: 0 0 0 1.5px #f87171;
          }

          &.preview-mode {
            border: 2px dashed #949494;
            background: rgba(148, 148, 148, 0.08);
            color: #949494;
            box-shadow: none;
            cursor: default;
            pointer-events: none;
            padding-right: 8px;
            display: flex;
            align-items: center;
            justify-content: flex-end;
          }

          .textbox-input {
            width: 100%;
            height: 100%;
            border: none;
            background-color: transparent;
            font-size: 12px;
            font-weight: bold;
            text-align: right;
            direction: rtl;
            padding: 5px;
            outline: none;
            color: #000000;

            &::placeholder {
              color: #137fec;
              font-weight: normal;
              opacity: 0.8;
            }

            &:focus {
              background: rgba(255, 255, 255, 0.5);
            }
          }

          .checkbox-input {
            width: 14px;
            height: 14px;
            cursor: pointer;
            -webkit-appearance: none;
            -moz-appearance: none;
            appearance: none;
            border: 2px solid #137fec;
            border-radius: 3px;
            background-color: transparent;
            margin: 0;
            padding: 0;
            position: relative;

            &:checked {
              background-color: #137fec;

              &::after {
                content: "✓";
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                color: white;
                font-size: 11px;
                font-weight: bold;
                line-height: 1;
              }
            }
          }
        }

        .Layout__Content__Page__Attributes__Item {
          background-color: rgba(19, 127, 236, 0.6);
          border: 2px dashed #137fec;
          border-radius: 5px;
          display: flex;
          justify-content: center;
          align-items: center;
          transition: box-shadow 0.2s ease;
          transform-origin: bottom left;
          font-weight: bold;
          font-size: 14px;
          color: white;
          z-index: 100;

          &.type-signature {
            background-size: contain;
            background-repeat: no-repeat;
            background-position: center;

            &.valid {
              color: transparent;
            }
          }

          &.focused {
            box-shadow: 0 0 0 1.5px #f87171;
          }

          &.valid {
            box-shadow: 0 0 0 1.5px #34d399;

            &:after {
              content: "✓";
              position: absolute;
              left: -32px;
              z-index: 14;
              top: 7px;
              width: 20px;
              height: 20px;
              border-radius: 50%;
              border: 2px solid #34d399;
              background-color: #34d399;
              display: flex;
              align-items: center;
              justify-content: center;
              color: white;
              font-weight: bold;
              font-size: 14px;
            }
          }

          &.preview-mode {
            border: 2px dashed #949494;
            background-color: rgba(148, 148, 148, 0.5);
            color: white;
            box-shadow: none;
            cursor: default;
            pointer-events: none;
          }
        }
        
        
        /* Styles for signed attributes (past signed) */
        .signed-attribute {
          pointer-events: none; /* Prevent interaction with signed attributes */
          z-index: 100;
        }
        
        .signed-text-field {
          display: flex;
          align-items: center;
          justify-content: center;
          
          .signed-text-content {
            display: block;
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            font-weight: bold;
            color: #000;
            text-align: center;
            padding: 2px 4px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        
        .signed-checkbox-field {
          background-color: rgba(255, 255, 255, 0.9);
          border: 1px solid rgba(0, 0, 0, 0.1);
          border-radius: 3px;
          box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
          display: flex;
          align-items: center;
          justify-content: center;
          
          .signed-checkbox {
            width: 15px;
            height: 15px;
            cursor: default;
            pointer-events: none;
          }
        }
      }
    }
  }
}

.Confirm__Buttons {
  display: flex;
}

.SignModal {
  .signature-icon {
    position: absolute;
    bottom: 160px;
    width: 55px;
    pointer-events: none;

    img {
      max-width: 100%;
    }
  }

  p {
    font-size: 13px;
    color: #8a8686;
  }

  .SignModal__Buttons {
    display: flex;
    justify-content: space-between;

    button {
      outline: none;
      transition: all 0.1s linear;
      border-radius: 3px;
    }

    .flat {
      background: none;
      color: dimgrey;
      background: #c0c0c038;

      &:hover {
        background: #c0c0c054;
      }

      &:active {
        background: #c0c0c070;
        color: black;
      }
    }
  }

  .Signature__Actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    top: 70px;
    left: 50%;
    width: 90%;
    margin: 0 auto;
    transform: translateX(-50%);
    z-index: 3;
    min-height: 35px;
  }

  .Signature__Actions .colors {
    display: flex;
    align-items: center;
  }

  .Signature__Actions .colors button {
    border-radius: 50%;
    border: none;
    margin: 0 5px;
    height: 17px;
    width: 17px;
    cursor: pointer;
    outline: none;
    position: relative;
    outline: none;
    transition: all 0.1s linear;
  }

  .Signature__Actions .colors button.selected {
    transform: scale(1.2);
  }

  .Signature__Actions .colors button.selected:after {
    content: "✓";
    position: absolute;
    color: white;
    font-size: 12px;
    top: 0;
    text-align: center;
    width: 100%;
    height: 100%;
    left: 0;
  }

  .Signature__Actions .clear {
    color: #464646;
    background-color: transparent;
    cursor: pointer;
    border: 1px solid #464646;
    border: none;
    border-radius: 3px;
    padding: 4px 10px;
    outline: none;
  }

  .Signature__Actions .clear:hover {
    background-color: #eaeaea;
  }

  .Signature__Actions button.blue {
    background-color: #039be5;
  }

  .Signature__Actions button.red {
    background-color: red;
  }

  .Signature__Actions button.black {
    background-color: black;
  }

  .file-label {
    font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", "Roboto",
      "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans",
      "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  }
}

.upload-button {
  min-width: 135px;
  label {
    font-family: sans-serif;
    cursor: pointer;
    margin-top: 1rem;
    background-color: #118dcf;
    opacity: 0.7;
    color: white;
    border: none;
    padding: 8px 32px;
    font-size: 14px;
    outline: none;
    border-radius: 3px;
  }

  .remove-stamp {
    font-family: sans-serif;
    cursor: pointer;
    margin-top: 1rem;
    background-color: #7367f0;
    opacity: 0.7;
    color: white;
    border: none;
    padding: 8px 32px;
    font-size: 14px;
    outline: none;
    border-radius: 3px;
    height: auto !important;
    width: auto !important;
    border-radius: 3px !important;
  }
}

.spinner {
  width: 40px;
  height: 40px;
  position: absolute;
  margin: auto auto;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}

.double-bounce1,
.double-bounce2 {
  width: 100%;
  height: 100%;
  -webkit-border-radius: 20px;
  -moz-border-radius: 20px;
  border-radius: 20px;
  background-color: #2e688c;
  opacity: 0.6;
  position: absolute;
  top: 0;
  left: 0;
  -webkit-animation: bounce 2s infinite ease-in-out;
  animation: bounce 2s infinite ease-in-out;
}

.double-bounce2 {
  -webkit-animation-delay: -1s;
  animation-delay: -1s;
}

@-webkit-keyframes bounce {

  0%,
  100% {
    -webkit-transform: scale(0);
  }

  50% {
    -webkit-transform: scale(1);
  }
}

@keyframes bounce {

  0%,
  100% {
    transform: scale(0);
    -webkit-transform: scale(0);
  }

  50% {
    transform: scale(1);
    -webkit-transform: scale(1);
  }
}

@media only screen and (max-width: 1000px) {
  .uploads {
    grid-template-columns: repeat(1, 1fr) !important;
    margin-top: 20px !important;
    width: 100% !important;
  }

  .upload-section {
    width: 100% !important;
  }
  .success {
    width: 100% !important;
  }
}

/* ── Narrow-screen "read mode" for message-type HTML (.hsv-content) ──
   Matches narrow viewports OR any touch device (phones/tablets). The
   touch clause keeps read-mode active even when the browser is forced
   into "Request Desktop Site" (which widens the layout viewport but
   does not change pointer/hover capabilities). */
@media only screen and (max-width: 700px),
       only screen and (hover: none) and (pointer: coarse) {
  /* The sticky header's inner bar is hard-coded to 793px. On the letter
     page (which has no 793px image pages) this is the only over-wide
     element, so after a "Request Desktop Site" toggle the browser derives
     a ~793px layout viewport from it and the letter renders against that
     instead of the screen. Cap it so the canvas matches the device. */
  .Layout__Content__Editor__Indicator div {
    width: 100% !important;
    max-width: 100% !important;
  }

  /* Let the editor go edge-to-edge so the letter can use the full width */
  .Layout__Content__Editor {
    padding: 0 !important;
    width: 100% !important;
    max-width: 100% !important;
  }

  /* The fixed 793px page becomes a fluid, full-width reading column */
  .Layout__Content__Page.html {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    align-self: stretch !important;
    margin: 0 !important;
    padding: 22px 18px 48px !important;
    display: block !important;          /* drop flex so the letter flows as a block */
    box-shadow: none !important;
    line-height: 1.7;
  }

  /* Reflow the injected letter and bump it to a comfortable reading size */
  .Layout__Content__Page.html ::v-deep(.hsv-content) {
    font-size: 16px !important;
    line-height: 1.75 !important;
    width: 100% !important;
    max-width: 100% !important;
    overflow-wrap: anywhere;
    word-break: break-word;
  }
  /* Nothing inside the letter may exceed the screen width */
  .Layout__Content__Page.html ::v-deep(.hsv-content *) {
    max-width: 100% !important;
  }
  .Layout__Content__Page.html ::v-deep(.hsv-content img) {
    height: auto !important;
  }
  .Layout__Content__Page.html ::v-deep(.hsv-content table) {
    width: 100% !important;
    table-layout: fixed;
  }
  /* Keep list indentation sane on small screens */
  .Layout__Content__Page.html ::v-deep(.hsv-content ul),
  .Layout__Content__Page.html ::v-deep(.hsv-content ol) {
    padding-right: 1.25em !important;
  }
}

/* Assignee-based colors for preview mode */
.ochre {
  background-color: rgba(34, 153, 238, 0.25) !important; /* Low alpha version */
  transition: background-color 0.2s ease;
  
  &:hover {
    background-color: rgba(40, 142, 238, 0.25) !important; /* Low alpha version */
  }
}

.light-gray {
  background-color: rgba(96, 125, 139, 0.25) !important; /* Low alpha version */
  transition: background-color 0.2s ease;
  
  &:hover {
    background-color: rgba(84, 110, 123, 0.25) !important; /* Low alpha version */
  }
}

.light-blue {
  background-color: rgba(0, 96, 223, 0.25) !important; /* Low alpha version */
  transition: background-color 0.2s ease;
  
  &:hover {
    background-color: rgba(0, 71, 179, 0.25) !important; /* Low alpha version */
  }
}

.teal {
  background-color: rgba(0, 121, 107, 0.25) !important; /* Low alpha version */
  transition: background-color 0.2s ease;
  
  &:hover {
    background-color: rgba(0, 121, 109, 0.25) !important; /* Low alpha version */
  }
}

.opening-modal {
  ::v-deep .sweet-content {
    font-size: 22px;
  }
}

.preview-saved-modal {
  ::v-deep .sweet-content {
    font-size: 22px;
  }
  
  ::v-deep .sweet-title {
    padding-left: 30px !important;
  }
  
  ::v-deep .sweet-modal-title {
    padding-left: 30px !important;
  }
  
  ::v-deep h2 {
    padding-left: 30px !important;
  }
}

/* ── iOS safe-area fixes for sweet-modal ───────────────────── */

/* All modals: never extend into the iPhone home-indicator zone */
::v-deep .sweet-modal {
  max-height: calc(100dvh - env(safe-area-inset-bottom, 0px));
}

/* Fullscreen mobile modal (signature pad): lift buttons above safe area */
::v-deep .sweet-modal.is-mobile-fullscreen .sweet-buttons {
  padding-bottom: #{max}(20px, env(safe-area-inset-bottom, 20px));
}
</style>
